import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { getConsent, OPEN_COOKIE_SETTINGS_EVENT, setConsent } from './consent';
import { COOKIES_PATH } from './legal/legalPaths';

// The cookie banner (consent.js): shown until they answer, and again from a "Cookie
// settings" link (openCookieSettings). A plain first version: restyle or swap it for your
// own design, keeping setConsent as what the buttons call. The privacy policy should
// describe tms_vid (13 months, which pages and events, where they came from) and that
// declining keeps only anonymous daily counts.
const CookieBanner = () => {
    const [open, setOpen] = useState(() => getConsent() === null);

    useEffect(() => {
        const show = () => setOpen(true);
        window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, show);
        return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, show);
    }, []);

    if (!open) return null;
    // Both buttons look the same, so saying no is as easy as saying yes
    const answer = (analytics) => {
        setConsent({analytics});
        setOpen(false);
    };
    return (
        <Paper elevation={6} role="dialog" aria-live="polite" aria-label="Cookies"
            sx={{position: 'fixed', zIndex: 1400, left: 16, right: 16, bottom: 16, maxWidth: 560, mx: 'auto', p: 2}}>
            <Typography variant="body2" sx={{mb: 1.5}}>
                With your OK we use analytics cookies, ours and Google Analytics', to see which pages and links
                bring people here and what they use, so we can improve the site. They're never used for ads. You
                can change your mind at any time from Cookie settings at the foot of the page or in the menu.
                See our <Link to={COOKIES_PATH} style={{color: 'inherit'}}>Cookie Policy</Link>.
            </Typography>
            <Box sx={{display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end'}}>
                <Button variant="contained" size="small" onClick={() => answer(false)}>Only necessary</Button>
                <Button variant="contained" size="small" onClick={() => answer(true)}>Accept analytics</Button>
            </Box>
        </Paper>
    );
};

export default CookieBanner;
